module.exports = __webpack_public_path__ + "img/bg2.4b2a7546.png";